import React, { memo, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { chipUseStyle } from "styles/chip";

import { Chip } from "@material-ui/core";

import { validateEmail } from "utils/utils";
import { landingPageStrings, NOTIFICATION_TABLE_COLUMNS, userProfileStrings, valueStrings } from "constants/constantStrings";

import DupontButton from "components/DupontButton";
import DupontCheckbox from "components/DupontCheckbox";
import DupontDialog from "components/DupontDialog";
import DupontIconButton from "components/DupontIconButton";
import InputBox from "components/InputBox";
import SelectDropDown from "components/SelectDropDown";

import CancelIcon from "assets/SvgIcon/Cancel";

import "react-phone-input-2/lib/style.css";
import "./index.scss";

const NotificationAddForm = memo(({ systems, onClose, isOverlayLoader }) => {
  const defaultValues = {
    Email: "",
    Mobile: null,
    StatusAlert: true,
    AlarmAlert: true,
    ReportAlert: true,
    InsightAlert: true,
    DisconnectDuration: 60,
    Systems: []
  };
  const [formData, setFormData] = useState(defaultValues);
  const [emailError, setEmailError] = useState(null);
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const [selectedSystems, setSelectedSystems] = useState([]);

  const chipClasses = chipUseStyle(this);
  const systemNames = systems?.systems[0] && systems?.systems.map(name => name.sysId);
  systemNames.sort();
  systemNames.unshift(landingPageStrings.all.trim());

  useEffect(() => {
    setIsFormInvalid(!formData.Email || emailError || !formData.Systems?.length);
  }, [formData, emailError]);

  const onEmailChange = Email => {
    setEmailError("");
    setFormData({ ...formData, Email });
    if (!validateEmail(Email)) {
      setEmailError(userProfileStrings.invalidEmail);
    }
  };

  const onCheckboxChange = (value, checkboxName) => {
    setFormData({ ...formData, [checkboxName]: value });
  };
  const onMobileChange = Mobile => {
    Mobile = Mobile ? `+${Mobile}` : "";
    if (Mobile) {
      setFormData({ ...formData, Mobile: Mobile });
    }
  };

  const isRemoveBtnDisabled = () => !selectedSystems?.length;

  const onSystemChange = Systems => {
    const allSelected = Systems?.includes(landingPageStrings.all.trim());
    if (Systems.length > 0 && allSelected) {
      systemNames.shift();
      setSelectedSystems(systemNames);
      setFormData({ ...formData, Systems: systemNames });
    } else {
      setSelectedSystems(Systems);
      setFormData({ ...formData, Systems: Systems });
    }
  };

  const onDialogClose = action => onClose(action, formData);

  const removeSystem = name => {
    let filteredSystem = [];
    if (name) {
      filteredSystem = selectedSystems?.filter(system => system !== name);
    }
    setSelectedSystems(filteredSystem);
    setFormData({ ...formData, Systems: filteredSystem });
  };

  return (
    <DupontDialog
      open
      title={userProfileStrings.addNotificationTitle}
      subTitle={userProfileStrings.addNotificationSubTitle}
      showisRequired={true}
      cancelBtnText={valueStrings.cancel}
      confirmBtnText={valueStrings.add}
      onClose={onDialogClose}
      confirmDisabled={isFormInvalid}
      isOverlayLoader={isOverlayLoader}
    >
      <div className="column">
        <InputBox
          labelText={`${userProfileStrings.emailid}*`}
          name="email"
          placeholder={userProfileStrings.addNotificationEmailPlaceHolder}
          value={formData.emailid}
          onChange={onEmailChange}
          errorMsg={emailError}
          customClass="form-group"
        />

        <div className="form-group">
          <SelectDropDown
            id="systems_dropdown"
            labelText={`${landingPageStrings.systems}*`}
            value={formData.Systems}
            onChange={onSystemChange}
            options={systemNames}
          />
        </div>

        <div className="bodyMainHeadingText form-group">{`${userProfileStrings.alertType}`}</div>
        <div className="padding-y-5">
          <DupontCheckbox
            checked
            id="alarm_alert_checkbox"
            name="AlarmAlert"
            labelText={userProfileStrings.alarmAlert}
            customClass="descriptionText"
            onChange={onCheckboxChange}
          />
        </div>
        <div className="padding-y-5">
          <DupontCheckbox
            checked
            id="report_alert_checkbox"
            name="ReportAlert"
            labelText={userProfileStrings.reportAlert}
            customClass="descriptionText"
            onChange={onCheckboxChange}
          />
        </div>
        <div className="padding-y-5">
          <DupontCheckbox
            checked
            id="status_alert_checkbox"
            name="StatusAlert"
            labelText={userProfileStrings.systemAlert}
            customClass="descriptionText"
            onChange={onCheckboxChange}
          />
        </div>
        <div className="padding-y-5">
          <DupontCheckbox
            checked
            id="insights_alert_checkbox"
            name="InsightAlert"
            labelText={NOTIFICATION_TABLE_COLUMNS.insightsAlert}
            customClass="descriptionText"
            onChange={onCheckboxChange}
          />
        </div>
      </div>
      <div className="column">
        <div className="bodyMainHeadingText mobile__label">
          {userProfileStrings.addNotificationMobile}&nbsp;
          <span className="mobile-info">({userProfileStrings.prefixCountryCode})</span>
        </div>

        <PhoneInput
          placeholder={userProfileStrings.addNotificationMobilePlaceHolder}
          inputClass="mobile-input"
          value={formData.mobile}
          onChange={onMobileChange}
          containerClass="form-group"
        />

        <div className="flex-between">
          <label className="bodyMainHeadingText">{userProfileStrings.selectedSystems}</label>

          <DupontButton
            id="remove_all_systems_btn"
            type="tertiary"
            customClass="remove-all-systems"
            disabled={isRemoveBtnDisabled()}
            onClick={() => removeSystem()}
          >
            {userProfileStrings.removeAll}
          </DupontButton>
        </div>
        <div className="form-group selected-system__background descriptionText">
          {formData.Systems?.length > 0
            ? formData.Systems.map(name => (
                <Chip
                  label={name}
                  className={chipClasses.root}
                  key={name}
                  onDelete={() => removeSystem(name)}
                  deleteIcon={
                    <DupontIconButton id="remove_system_btn" isRemove={true} tooltip="Remove">
                      <CancelIcon type="remove" />
                    </DupontIconButton>
                  }
                />
              ))
            : valueStrings.noSystemStr}
        </div>

        <div className="form-group">
          <InputBox id="disconnected_duration_input" labelText={`${userProfileStrings.disconnectionDuration}`} disabled value="1 min" />
        </div>
      </div>
    </DupontDialog>
  );
});
NotificationAddForm.displayName = "NotificationAddForm";
export default NotificationAddForm;
